import { useSelector } from 'react-redux';

export function useUser(): any {
   return useSelector<any>((store: any) => store.user) as any;
}
